import React from 'react';
import Mark from '../common_components/design_components/Mark';
import CmykSmall from '../common_components/design_components/CmykSmall';
import "../styles/mobile/FooterMobile.scss";

function FooterMobile() {
    return (    
    <div className="footer-container">
        <div className="footer-icons">
            {/* <div className="mark-container"> */}
                {/* <Mark /> */}
            {/* </div> */}
            <div className="cmyk-small-container"> 
                <Mark />
                <CmykSmall />
            </div>
        </div>
    </div>
    )
}

export default FooterMobile
